import AdminService from './AdminService.js';

const service = new AdminService();

export default {
  key: 'admin',
  namespaced: true,
  state: {},
  actions: {
    index() {
      return service.index();
    },
    featureIdeas({ commit }, payload = {}) {
      return service.featureIdeas(payload);
    },
    feedback({ commit }, payload = {}) {
      return service.feedback(payload);
    },
    productFeedback({ commit }, payload = {}) {
      return service.productFeedback(payload);
    },
    requestDebug({ commit }, payload = {}) {
      return service.requestDebug(payload);
    },
    searchUsers({ commit }, payload = {}) {
      return service.searchUsers(payload);
    },
    surveyResponses({ commit }, payload = {}) {
      return service.surveyResponses(payload);
    },
    updateFeatureIdea({ commit }, payload = {}) {
      return service.updateFeatureIdea(payload.id, payload);
    },
    updateProductFeedback({ commit }, payload = {}) {
      return service.updateProductFeedback(payload.id, payload);
    },
    deleteProductFeedback({ commit }, payload = {}) {
      return service.deleteProductFeedback(payload.id);
    },
  },
  mutations: {},
};
